import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { AvEmptyStateComponent } from '../../../../Shared/Components/av-empty-state/av-empty-state.component';
import { AvStatusChipComponent } from '../../../../Shared/Components/av-status-chip/av-status-chip.component';
import { VALUE_UNRESOLVED } from '../../../../../Consts/backoffice.const';
import { MetricState } from '../../../../Shared/Types/metric-state.type';
import { PlanRevenue } from '../../../../../Models/backoffice/plan-revenue.model';

@Component({
  selector: 'av-plan-revenue-table',
  standalone: true,
  imports: [DecimalPipe, AvEmptyStateComponent, AvStatusChipComponent, TranslatePipe],
  templateUrl: './plan-revenue-table.component.html',
  styleUrl: './plan-revenue-table.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'd-block' },
})
export class PlanRevenueTableComponent {
  readonly rows = input.required<PlanRevenue[]>();
  readonly state = input<MetricState>('loading');
  readonly currency = input<string | null>(null);

  readonly unresolved = VALUE_UNRESOLVED;

  currencyOf(row: PlanRevenue): string {
    return row.currency ?? this.currency() ?? this.unresolved;
  }
}
